import { createFileRoute } from "@tanstack/react-router";
import { CustomizationPage } from "@/components/solutions/CustomizationPage";
import { customizationSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/customization")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => customizationSeo(loaderData?.href ?? "/solutions/customization"),
  component: CustomizationPage,
});
